import React from "react";
import { TransactionHistory } from "@components/auditLog/transaction/TransactionHistory";
import { AuditLog } from "@common/types/auditLog";
import { ActivityTimeline } from "@design-system/ActivityTimeline/ActivityTimeline";

interface Props {
    displayedLogs: AuditLog[];
}

export const TransactionDetailsHistoryNew: React.FC<Props> = ({
    displayedLogs,
}) => {
    if (!displayedLogs.length) {
        return null;
    }

    return (
        <ActivityTimeline data-testid="transaction-details-history">
            {displayedLogs.map((log) => (
                <TransactionHistory log={log} key={log.id} />
            ))}
        </ActivityTimeline>
    );
};
